import { Toaster, toast as hotToast, ToastOptions } from 'react-hot-toast';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const StyledToaster = styled(Toaster)`
  .toast-rtl {
    direction: rtl;
    text-align: right;
    font-family: ${theme.fonts.primary};
  }
`;

export const ToastProvider: React.FC = () => {
  return (
    <StyledToaster
      position="top-left"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 4000,
        className: 'toast-rtl',
        style: {
          background: theme.colors.background,
          color: theme.colors.text,
          padding: theme.spacing.md,
          borderRadius: theme.borderRadius.md,
          boxShadow: theme.shadows.lg,
          fontFamily: theme.fonts.primary,
          fontSize: theme.fontSizes.md,
          direction: 'rtl',
          textAlign: 'right',
        },
        success: {
          iconTheme: {
            primary: theme.colors.success,
            secondary: theme.colors.background,
          },
          style: {
            border: `2px solid ${theme.colors.success}`,
          },
        },
        error: {
          iconTheme: {
            primary: theme.colors.error,
            secondary: theme.colors.background,
          },
          style: {
            border: `2px solid ${theme.colors.error}`,
          },
        },
      }}
    />
  );
};

interface ToastMessage {
  success: (message: string, options?: ToastOptions) => void;
  error: (message: string, options?: ToastOptions) => void;
  loading: (message: string, options?: ToastOptions) => string;
  dismiss: (toastId?: string) => void;
  promise: <T>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    },
    options?: ToastOptions
  ) => Promise<T>;
}

export const toast: ToastMessage = {
  success: (message: string, options?: ToastOptions) => {
    return hotToast.success(message, options);
  },
  error: (message: string, options?: ToastOptions) => {
    return hotToast.error(message, options);
  },
  loading: (message: string, options?: ToastOptions) => {
    return hotToast.loading(message, options);
  },
  dismiss: (toastId?: string) => {
    return hotToast.dismiss(toastId);
  },
  promise: <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    },
    options?: ToastOptions
  ) => {
    return hotToast.promise(promise, messages, options);
  },
};
